export default "__VITE_ASSET__cb9c7e27__"